import React from 'react';
export function Terms() {
  return <div className="py-16 px-4 max-w-4xl mx-auto w-full" data-id="element-411">
      <div className="mb-12 border-b border-neutral-800 pb-8" data-id="element-412">
        <h1 className="font-display text-5xl tracking-wide mb-4" data-id="element-413">
          VSC Clothing Terms of Service
        </h1>
        <p className="text-neutral-300 font-medium" data-id="element-414">
          VSCCLOTHING d/b/a VSC Clothing
        </p>
        <p className="text-neutral-400 mt-1" data-id="element-415">
          312 S 4th Street Downtown, Louisville, KY 40202
        </p>
      </div>

      <div className="prose prose-invert prose-neutral max-w-none space-y-8" data-id="element-416">
        <section data-id="element-417">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-418">
            Acceptance of Terms
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-419">
            By accessing or using the VSC Clothing website, you agree to be
            bound by these Terms of Service. If you do not agree to all the
            terms and conditions, then you may not access the website or use any
            services.
          </p>
        </section>

        <section data-id="element-420">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-421">
            Products &amp; Orders
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-422">
            All products are subject to availability. We reserve the right to
            limit the quantities of any products or services that we offer. All
            descriptions of products or product pricing are subject to change at
            anytime without notice, at our sole discretion. We reserve the right
            to discontinue any product at any time.
          </p>
        </section>

        <section data-id="element-423">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-424">Payment</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-425">
            We accept major credit cards and other payment methods as indicated
            at checkout. You agree to provide current, complete, and accurate
            purchase and account information for all purchases made at our
            store.
          </p>
        </section>

        <section data-id="element-426">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-427">
            Shipping &amp; Returns
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-428">
            Shipping costs and delivery times vary depending on the destination.
            We offer a 14-day return policy for unworn, unwashed items with
            original tags attached. Please review our full return policy on our
            website for detailed instructions.
          </p>
        </section>

        <section data-id="element-429">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-430">
            Intellectual Property
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-431">
            All content included on this site, such as text, graphics, logos,
            images, and software, is the property of VSC Clothing or its content
            suppliers and protected by international copyright laws.
          </p>
        </section>

        <section data-id="element-432">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-433">
            Limitation of Liability
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-434">
            In no case shall VSC Clothing, our directors, officers, employees,
            affiliates, agents, contractors, interns, suppliers, service
            providers or licensors be liable for any injury, loss, claim, or any
            direct, indirect, incidental, punitive, special, or consequential
            damages of any kind.
          </p>
        </section>

        <section data-id="element-435">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-436">
            Governing Law
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-437">
            These Terms of Service and any separate agreements whereby we
            provide you services shall be governed by and construed in
            accordance with the laws of the State of Kentucky.
          </p>
        </section>

        <section data-id="element-438">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-439">Contact</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-440">
            Questions about the Terms of Service should be sent to us at:
            <br data-id="element-441" />
            <br data-id="element-442" />
            VSCCLOTHING d/b/a VSC Clothing
            <br data-id="element-443" />
            312 S 4th Street Downtown
            <br data-id="element-444" />
            Louisville, KY 40202
            <br data-id="element-445" />
            <a href="mailto:vscclothing5@gmail.com" className="underline hover:text-white" data-id="element-446">
              vscclothing5@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>;
}